import * as zod from 'zod';

export const validationLogin = zod.object({
  email: zod
    .string({ required_error: 'O campo avenida não pode ser vazio.' })
    .email({ message: 'Informe um email válido'}),
  password: zod
    .string({ required_error: 'O campo rua não pode ser vazio.' })
    .max(191, { message: 'O campo pode conter no máxiom 191 caracteres' })
    .min(1, { message: 'O campo pode conter no mínimo 1 caracteres' }),
});


export type formLogin = zod.infer<typeof validationLogin>;